export default __webpack_public_path__ + "static/media/logo-home-caixa.4a581a98.svg";